import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { deleteMenuAberto, deleteTelaAberta } from 'services/authentication/auth';
import { useMenuSidebar } from 'contexts/MenuSidebarContext';
import { deleteRegistrosTemporarios } from 'api/capitalFlow';
import { useNavigate } from 'react-router-dom';

const ModalCancelarCessao = ({ open, onClose }) => {
  const { esconderMenuPrincipal } = useMenuSidebar();
  const navigate = useNavigate();

  const cancelarCesssao = () => {
    deleteRegistrosTemporarios();
    esconderMenuPrincipal();
    deleteMenuAberto();
    deleteTelaAberta();
    onClose();
    navigate('/home');
  };

  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose} fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Cancelar cessão</DialogTitle>
      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Deseja realmente cancelar esta cessão? Após confirmar, não será possível recuperar esta
          operação e todas as informações serão perdidas.
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button onClick={onClose} className="dialog-conta__btn-cancelar">
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => cancelarCesssao()}
          className="dialog-conta__btn-escolher"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCancelarCessao;
